// extracted by mini-css-extract-plugin
export default {"wrapper":"Box_wrapper__xSvjg","icon":"Box_icon__ydgtV","title":"Box_title__RDlX2","text":"Box_text__OWBPV"};